import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { Stack } from '@mui/material';

export default function Toggle(props) {
  const { tValue, size, handleChange, value, selectedId, ...others } = props;

  return (
    <Stack direction="row" spacing={4}>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        size={size || 'small'}
        {...others}
      >
        {tValue.map((item) => (
          <ToggleButton
            value={item}
            key={item.id}
            selected={item.value === selectedId ? true : false}
            aria-label="left aligned"
          >
            {item.text}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
}
